<template>
  <div class="home">
    <el-tabs type="border-card" class="fullHeight">
      <el-tab-pane class="paddingBody" :label="$t('Tarea')">
        <el-row>
          <el-col :md="11">
            <el-form onsubmit="return false;" label-position="top">
              <b>
                <el-form-item
                  label="Paso del proceso"
                  :class="{ intermitente: taskName === '' ? true : false }"
                >
                  <el-input size="medium" placeholder="Nombre paso del proceso" v-model="taskName"></el-input>
                  <br />
                  <span
                    v-if="taskName === ''"
                    class="messageTask fontRed"
                  >(*) Ingresa el nombre de paso del proceso para continuar.</span>
                </el-form-item>
              </b>
            </el-form>
          </el-col>
          <el-col :offset="3" :md="10">
            <StepsInventario v-bind:step="0" />
          </el-col>
        </el-row>

        <h4 v-if="taskName !== ''" class="help-instructions">
          Seleccione el o los
          <b>Riesgos Transversales</b> que se apliquen a su tarea.
          En caso de no encontrar alguno, puede ingresar un
          <b>Nuevo Riesgo</b> o
          <b>Evento Top</b> a su tarea.
        </h4>

        <br />
        <el-row :gutter="20" v-if="taskName !== ''">
          <el-col :md="11">
            <h1>Riesgos transversales</h1>
            <br />
            <el-button
              icon="el-icon-plus"
              @click="openDialogAddSecurityRisk"
              size="medium"
              class="colorSeguridad"
            >Seguridad</el-button>
          </el-col>
          <el-col :md="10">
            <h1>Nuevo Riesgo o Aspecto Ambiental</h1>
            <br />
            <el-button
              @click="openDialogAddCustomRisk"
              icon="el-icon-plus"
              size="medium"
              class="colorCustom"
            >Agregar riesgo</el-button>
          </el-col>
        </el-row>

        <br />
        <br />

        <span v-if="taskName !== ''">
          Cantidad de riesgos:
          <b>{{cantidadRiesgos}}</b>
        </span>
        <el-table
          border
          :header-cell-style="function () { return 'background-color: rgb(7, 116, 141); color: white; padding: 0px;'}"
          empty-text="Sin riesgos registrados"
          v-if="taskName !== ''"
          :max-height="700"
          class="tableRisks"
          :data="$store.getters.inventario.tareas[$store.getters.selectedIndexTask].riesgos"
          style="width: 100%"
          :cell-class-name="pintar"
          header-cell-class-name="headerCell"
        >
          <el-table-column type="expand" width="30" align="center" :key="componentKey">
            <template slot-scope="scope">
              <el-row>
                <el-col :span="8">
                  <h4>Causas</h4>
                  <ol>
                    <li v-for="(item, index) in scope.row.causas" :key="index">{{item.nombre}}</li>
                  </ol>
                </el-col>
                <el-col :span="8">
                  <h4>Controles Preventivos</h4>
                  <ol>
                    <li
                      :class="{fontRed: control.critico}"
                      v-for="(control, i) in getControlesPreventivos(scope.row)"
                      v-bind:key="i"
                    >{{control.nombre}}</li>
                  </ol>
                </el-col>
                <el-col :span="8">
                  <h4>Controles Mitigadores</h4>
                  <ol>
                    <li
                      v-for="(control, i) in getControlesMitigadores(scope.row)"
                      v-bind:key="i"
                    >{{control.nombre}}</li>
                  </ol>
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column width="130" align="center">
            <template slot-scope="scope">
              <el-button
                size="small"
                plain
                type="danger"
                @click="deleteRisk(scope.row)"
                icon="el-icon-delete"
              />
              <el-button
                size="small"
                plain
                type="info"
                @click="openEditRisk(scope.row)"
                icon="el-icon-edit"
              />
            </template>
          </el-table-column>
          <el-table-column prop="nombre" label="Nombre" />
          <el-table-column width="150" align="center" label="Categoría">
            <template slot-scope="scope">{{scope.row.tipo ? MaysPrimera(scope.row.tipo) : ""}}</template>
          </el-table-column>
          <el-table-column align="center" label="Sin Controles">
            <el-table-column width="150" align="center" label="Severidad">
              <template
                slot-scope="scope"
              >{{(scope.row.sin_controles && scope.row.sin_controles.severidad) ? scope.row.sin_controles.severidad : "---"}}</template>
            </el-table-column>
            <el-table-column width="150" align="center" label="Probabilidad">
              <template
                slot-scope="scope"
              >{{(scope.row.sin_controles && scope.row.sin_controles.probabilidad) ? scope.row.sin_controles.probabilidad : "---"}}</template>
            </el-table-column>
            <el-table-column width="150" align="center" label="Indice de Riesgo">
              <template
                slot-scope="scope"
              >{{(scope.row.sin_controles && scope.row.sin_controles.probabilidad && scope.row.sin_controles.severidad) ? (scope.row.sin_controles.probabilidad * scope.row.sin_controles.severidad) : "---"}}</template>
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" label="Con Controles">
            <el-table-column width="150" align="center" label="Severidad">
              <template
                slot-scope="scope"
              >{{(scope.row.con_controles && scope.row.con_controles.severidad) ? scope.row.con_controles.severidad : "---"}}</template>
            </el-table-column>
            <el-table-column width="150" align="center" label="Probabilidad">
              <template
                slot-scope="scope"
              >{{(scope.row.con_controles && scope.row.con_controles.probabilidad) ? scope.row.con_controles.probabilidad : "---"}}</template>
            </el-table-column>
            <el-table-column width="150" align="center" label="Indice de Riesgo">
              <template
                slot-scope="scope"
              >{{(scope.row.con_controles && scope.row.con_controles.probabilidad && scope.row.con_controles.severidad) ? (scope.row.con_controles.probabilidad * scope.row.con_controles.severidad) : "---"}}</template>
            </el-table-column>
          </el-table-column>
        </el-table>

        <InventarioBowtie
          :taskName="taskName"
          :editRisk="editRisk"
          :saveChange="saveChange"
          :action="action"
          :onAcept="addCustomRisk"
          :onClose="handleClose"
          :visibleSync="openDialogBowtie"
          :editable="true"
          :risk="newCustomRisk"
          :allStandardRisks="risks"
          :riskItem="riskItem"
          :closeDialogCustomRisk="closeDialogCustomRisk"
        />
        <br />
        <div v-if="taskName !== ''">
          <el-alert
            v-if="cantidadRiesgos === 0"
            title="Atención"
            type="warning"
            :description="`No hay ningún riesgo asociado a la tarea ${taskName}, para continuar debes agregar como mínimo uno.`"
            show-icon
            :closable="false"
          ></el-alert>
        </div>
        <br />
        <div class="text-right">
          <el-button type="info" size="medium" @click="previousStep" class="big-submit">Regresar</el-button>
          <el-button
            class="big-submit"
            size="medium"
            type="primary"
            :loading="isLoading"
            @click="nextStep"
            :disabled="cantidadRiesgos === 0 || taskName === ''"
          >Siguiente</el-button>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- Dialogs -->
    <dialogTableSecurityRisks
      :onCancel="handleClose"
      :onAcept="riskItem"
      :risks="estandarizedSecurityRisks"
      :visibleSync="dialogAddSecurityRisk"
      :title="$t('Riesgos Transversales de Seguridad')"
      :handleSelectionChange="handleSelectionChange"
    />

    <el-dialog :before-close="handleClose" title="Agregando" :visible="dialogNewCustomRisk">
      <el-form>
        <el-form-item label="Nombre">
          <el-input
            class="with-help-box"
            v-model="formCustomRisk.nombre"
            auto-complete="on"
            @keydown.native.enter.prevent
            @keyup.native.enter="addCustomRisk('formCustomRisk')"
          />
          <el-popover
            class="help-box"
            placement="right"
            title="Nombre del riesgo"
            width="200"
            trigger="hover"
            content="Escriba el nombre del 'Riesgo o Aspecto Ambiental' que desee agregar.
            El nombre debe ser breve, claro y preciso, de no más de una línea."
          >
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label="Tipo">
          <el-radio-group v-model="formCustomRisk.tipo" class="with-help-box">
            <el-radio-button label="Salud y Seguridad"></el-radio-button>
            <el-radio-button label="Medioambiental"></el-radio-button>
          </el-radio-group>
          <el-popover
            class="help-box"
            placement="right"
            title="Tipo del riesgo"
            width="200"
            trigger="hover"
            :content="$t('Seleccione el tipo del \'Riesgo o Aspecto Ambiental\' que desee agregar. Solo puedes seleccionar uno.')"
          >
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <p v-if="standard_risk_found">{{ standard_risk_message }}</p>
        <div v-if="!noStandardRiskLeft">
          <div v-for="standard_risk in standard_risks" :key="standard_risk.name">
            <label>
              <input
                type="radio"
                name="standard_risks"
                :value="standard_risk.id"
                v-model="formCustomRisk.standardRisk"
                @change="enableStandardRiskButton"
              />
              {{ standard_risk.name }}
            </label>
          </div>
        </div>
        <div v-if="noStandardRiskLeft">
          <ul v-for="standard_risk in standard_risks_original" :key="standard_risk.name">
            <li>{{ standard_risk.name }}</li>
          </ul>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogCustomRisk">Cancelar</el-button>
        <el-button
          :disabled="!standardRiskButtonEnabled"
          type="primary"
          @click="addCustomRiskSRR('formCustomRisk')"
          v-if="standard_risk_found"
        >Agregar Riesgo Estandarizado</el-button>
        <el-button
          type="primary"
          @click="addCustomRisk('formCustomRisk')"
          v-if="!standard_risk_found"
        >Agregar</el-button>
      </span>
    </el-dialog>

    <el-dialog :before-close="handleClose" title="Editando" :visible="dialogEditCustomRisk">
      <el-form>
        <el-form-item label="Nombre">
          <el-input v-model="formCustomRisk.nombre" class="with-help-box" auto-complete="on" />
          <el-popover
            class="help-box"
            placement="right"
            title="Nombre del riesgo"
            width="200"
            trigger="hover"
            content="Escriba el nombre del 'Riesgo o Aspecto Ambiental'.
            El nombre debe ser breve, claro y preciso, de no más de una línea."
          >
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
        <el-form-item label="Tipo">
          <el-radio-group v-model="formCustomRisk.tipo" class="with-help-box">
            <el-radio-button label="Salud y Seguridad"></el-radio-button>
            <el-radio-button label="Medioambiental"></el-radio-button>
          </el-radio-group>
          <el-popover
            class="help-box"
            placement="right"
            title="Tipo del riesgo"
            width="200"
            trigger="hover"
            content="Seleccione el tipo del 'Riesgo o Aspecto Ambiental'.
            Solo puedes seleccionar uno."
          >
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogEditCustomRisk()">Cancelar</el-button>
        <el-button type="primary" @click="editCustomRisk('formCustomRisk')">Modificar</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Atención" :visible.sync="dialogError" width="42%" :before-close="handleClose">
      <h1>Para continuar debes corregir los siguientes errores</h1>
      <br />
      <ol>
        <li v-for="(error, index) in errores" :key="index">{{error}}</li>
      </ol>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" type="primary" @click="dialogError = false">Cerrar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ImagesLoaded from "vue-images-loaded";
import uuid from "uuid/v4";

import dialogTableSecurityRisks from "@/components/dialogTableRisks.vue";
import InventarioBowtie from "@/components/DialogInventarioBowtie.vue";
import StepsInventario from "@/components/StepsInventario.vue";
import { getMFL } from "@/utils/generalFunctions";

export default {
  name: "FirstStep",
  data() {
    return {
      editRisk: false,
      taskName: this.$store.getters.inventario.tareas[
        this.$store.getters.selectedIndexTask
      ].nombre,
      errores: [],
      dialogError: false,
      componentKey: 0,
      indexEdit: null,
      action: "",
      newCustomRisk: {
        _id: "",
        nombre: "",
        tipo: "seguridad",
        evento_no_deseado: "",
        control_adicional: "",
        energia: "",
        calculo_mfl: "",
        peligro: "",
        standardRisk: false,
        material: false,
        causas: [],
        custom: true,
        impactos: [],
        escenario: "",
        justificacion_evaluacion: "",
        kri: [],
        escenario_residual: "",
        escenario_mfl: "",
        faena_id: "",
        medioambiental: false,
        medioambiente: {},
        evaluadores: [],
        sin_controles: {
          severidad: 0,
          probabilidad: 0
        },
        con_controles: {
          severidad: 0,
          probabilidad: 0
        },
        responsable: "",
        fecha: ""
      },
      openDialogBowtie: false,
      estandarizedSecurityRisks: [],
      estandarizedHealthRisks: [],
      estandarizedMedioambienteRisks: [],
      risksSelected: [],
      dialogAddMedioambienteRisks: false,
      dialogAddSecurityRisk: false,
      dialogAddHealthRisks: false,
      dialogNewCustomRisk: false,
      dialogEditCustomRisk: false,
      filterSelected: "*",
      customRiskId: null,
      standard_risks: [],
      standard_risks_original: [],
      standard_risk_message: "",
      standard_risk_found: false,
      standardRiskButtonEnabled: false,
      noStandardRiskLeft: false,
      srrLoading: false,
      formCustomRisk: {
        nombre: null,
        tipo: null,
        standardRisk: null
      },
      isLoading: false
    };
  },
  created() {
    this.$store.dispatch("setTitle", this.$t("Creando Inventario de Riesgos"));
    this.$store.dispatch(
      "setSubTitle",
      `${this.$t("Contrato")}: ${this.$store.getters.actualContract.nombre}`
    );
    this.$store.dispatch("getAllRisks");
    this.$store.dispatch("getAreasFaena");
  },
  components: {
    StepsInventario,
    dialogTableSecurityRisks,
    InventarioBowtie
  },
  directives: {
    ImagesLoaded
  },
  computed: {
    role() {
      return this.$store.getters.role;
    },
    mel() {
      return this.role.faena_id === "5a6f78337b772dcfe68241d5";
    },
    cantidadRiesgos() {
      if (
        this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos
      ) {
        return this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.length;
      }
      return 0;
    },
    areas() {
      return this.$store.getters.areas;
    },
    securityRisks() {
      return this.risks.filter(
        el => el.impactos[0].categoria.toLowerCase() === "seguridad"
      );
    },
    healthRisks() {
      return this.risks.filter(
        el => el.impactos[0].categoria.toLowerCase() === "salud"
      );
    },
    medioambienteRisks() {
      return this.risks.filter(
        el =>
          el.impactos[0].categoria.toLowerCase() === "medioambiente" ||
          el.impactos[0].categoria.toLowerCase() === "medioambiental"
      );
    },
    ...mapGetters({
      risks: "allRisks",
      isLoggedIn: "isLoggedIn"
    })
  },
  methods: {
    MaysPrimera(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    assignTaskName() {
      this.$store.dispatch("editTask", {
        taskId:
          this.$store.getters.inventario.tareas[
            this.$store.getters.selectedIndexTask
          ].id ||
          this.$store.getters.inventario.tareas[
            this.$store.getters.selectedIndexTask
          ]._id,
        nombre: this.taskName
      });
      this.saveInventory();
    },
    pintar({ row, column, rowIndex, columnIndex }) {
      let classes = "cellClassTabla ";
      if (columnIndex === 0) {
        if (row.custom === true) {
          classes += "colorCustom";
        } else if (row.impactos[0].categoria === "Seguridad" && !row.custom) {
          classes += "colorSeguridad";
        } else if (row.impactos[0].categoria === "Salud" && !row.custom) {
          classes += "colorSalud";
        } else if (
          row.impactos[0].categoria === "Salud y Seguridad" &&
          !row.custom
        ) {
          classes += "colorMedioambiente";
        }
      }
      return classes;
    },
    saveInventory() {
      this.$store.dispatch("createOrUpdateDraft").then(response => {
        if (response.success) {
          this.$store.dispatch("clearUserContract");
          this.$notify({
            duration: 3000,
            title: "Atención",
            message: "Cambios guardados exitosamente",
            type: "success"
          });
        } else {
          this.$alert(response.message, this.$t("Error"), {
            type: "error"
          });
        }
      });
    },
    saveChange(risk) {
      if (this.isRiskReady(risk).status === true) {
        this.$store.dispatch("editCustomRisk", risk);
        this.$notify.info({
          duration: 3000,
          title: "Atención",
          message: `Riesgo ${risk.nombre} modificado exitosamente`
        });
        this.resetStatusRisk();
        this.forceRerender();
        this.handleClose();
        this.saveInventory();
      } else {
        let textError = "";
        for (
          let index = 0;
          index < this.isRiskReady(this.newCustomRisk).errors.length;
          index++
        ) {
          textError = `${textError}<li class="listaError">${
            this.isRiskReady(this.newCustomRisk).errors[index]
          }</li>`;
        }
        this.$alert(`<ol class="listaError">${textError}</ol>`, "Atención", {
          type: "error",
          dangerouslyUseHTMLString: true
        });
      }
    },
    resetStatusRisk() {
      this.newCustomRisk.status = 0;
      this.newCustomRisk.status_step = 0;
      this.newCustomRisk.status_by = null;
      this.newCustomRisk.status_position = null;
      this.newCustomRisk.status_message = null;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    validarRiesgosSeguridad() {
      this.estandarizedSecurityRisks = JSON.parse(
        JSON.stringify(this.securityRisks)
      );
      if (
        this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos
      ) {
        this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.forEach(element => {
          const index = this.estandarizedSecurityRisks.findIndex(
            x => x._id === element._id
          );
          if (index !== -1) {
            this.estandarizedSecurityRisks.splice(index, 1);
          }
        });
      }
    },
    getControlesMitigadores(risk) {
      const controles = [];
      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;
          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach(control => {
              control.id_impacto = id;
              control.impactoId = impacto.id;
              controles.push(control);
            });
          }
        });
      }
      return controles;
    },
    getControlesPreventivos(risk) {
      const controlesIndicator = {};
      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const humanID = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach(control => {
              if (!controlesIndicator[control.nombre]) {
                controlesIndicator[control.nombre] = {};
                controlesIndicator[control.nombre].critico = control.critico;
                controlesIndicator[control.nombre].id = control.id;
              }
              if (!controlesIndicator[control.nombre].causasHumanID) {
                controlesIndicator[control.nombre].causasHumanID = [];
                controlesIndicator[control.nombre].causasID = [];
              }
              controlesIndicator[control.nombre].causasHumanID.push(humanID);
              controlesIndicator[control.nombre].causasID.push(causa.id);
            });
          }
        });
      }
      const controles = Object.keys(controlesIndicator).map(key => ({
        causasHumanID: controlesIndicator[key].causasHumanID,
        causasID: controlesIndicator[key].causasID,
        nombre: key,
        critico: controlesIndicator[key].critico,
        id: controlesIndicator[key].id
      }));
      return controles;
    },
    handleSelectionChange(risks) {
      this.risksSelected = risks;
    },
    openDialogAddSecurityRisk() {
      this.dialogAddSecurityRisk = true;
      this.validarRiesgosSeguridad();
    },
    openDialogAddCustomRisk() {
      this.action = "add";
      this.openDialogBowtie = true;
      this.setIdRisk();
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return "danger";
      }
      if (mfl === 3) {
        return "warning";
      }
      return "gray";
    },
    enableStandardRiskButton() {
      this.standardRiskButtonEnabled = true;
    },
    handleClose() {
      this.dialogError = false;
      this.openDialogBowtie = false;
      this.dialogNewCustomRisk = false;
      this.dialogEditCustomRisk = false;
      this.dialogAddSecurityRisk = false;
      this.risksSelected = [];
      this.dialogAddHealthRisks = false;
      this.dialogAddMedioambienteRisks = false;
      this.newCustomRisk = {
        _id: "",
        nombre: "",
        tipo: "seguridad",
        evento_no_deseado: "",
        control_adicional: "",
        energia: "",
        calculo_mfl: "",
        peligro: "",
        standardRisk: false,
        material: false,
        causas: [],
        custom: true,
        impactos: [],
        escenario: "",
        justificacion_evaluacion: "",
        kri: [],
        escenario_residual: "",
        escenario_mfl: "",
        faena_id: "",
        medioambiental: false,
        medioambiente: {},
        evaluadores: [],
        sin_controles: {
          severidad: 0,
          probabilidad: 0
        },
        con_controles: {
          severidad: 0,
          probabilidad: 0
        },
        responsable: "",
        fecha: ""
      };
      this.editRisk = false;
    },
    openEditRisk(risk) {
      risk.tipo = "seguridad";
      if (!risk["sin_controles"]) {
        risk["sin_controles"] = {};
        risk["sin_controles"]["severidad"] = 0;
        risk["sin_controles"]["probabilidad"] = 0;
      }
      if (!risk["con_controles"]) {
        risk["con_controles"] = {};
        risk["con_controles"]["severidad"] = 0;
        risk["con_controles"]["probabilidad"] = 0;
      }
      this.newCustomRisk = JSON.parse(JSON.stringify(risk));
      this.action = "edit";
      this.openDialogBowtie = true;
      this.editRisk = true;
    },
    filter(option) {
      this.filterSelected = option;
      this.$refs.cpt2.filter("byArea");
    },
    riskItem() {
      this.risksSelected.forEach(element => {
        this.$store.dispatch("addRisk", element);
      });
      this.$notify.info({
        duration: 3000,
        title: "Atención",
        message: "Riesgos Transversales se agregaron exitosamente"
      });
      this.saveInventory();
      this.handleClose();
    },
    addCustomRisk() {
      var findRisk = this.$store.getters.inventario.tareas[
        this.$store.getters.selectedIndexTask
      ].riesgos
        ? this.$store.getters.inventario.tareas[
            this.$store.getters.selectedIndexTask
          ].riesgos.find(
            risk =>
              risk.nombre.toLowerCase() ===
              this.newCustomRisk.nombre.toLowerCase()
          )
        : false;
      if (findRisk) {
        this.$message({
          message:
            "Advertencia, El riesgo que estás ingresando ya se encuentra registrado en el inventario, por favor verifíquelo.",
          type: "warning"
        });
      } else {
        if (this.isRiskReady(this.newCustomRisk).status === true) {
          this.$store.dispatch("addRisk", this.newCustomRisk);
          this.$notify.info({
            duration: 3000,
            title: "Atención",
            message: `Riesgo ${this.newCustomRisk.nombre} fue agregado exitosamente`
          });
          this.saveInventory();
          this.handleClose();
        } else {
          this.errores = [];
          for (
            let index = 0;
            index < this.isRiskReady(this.newCustomRisk).errors.length;
            index++
          ) {
            this.errores.push(
              this.isRiskReady(this.newCustomRisk).errors[index]
            );
          }
          this.dialogError = true;
        }
      }
    },
    isRiskReady(risk) {
      const errors = [];
      if (risk && risk.custom === true) {
        // Verifica que exista nombre en el riesgo
        if (risk.nombre === "") {
          errors.push(
            `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "no tiene un nombre asociado"
            )}`
          );
        }
        // Verifica que exista nombre en el riesgo
        if (risk.tipo === null) {
          errors.push(
            `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "no tiene un tipo asociado"
            )}`
          );
        }
        // Verifica que existan causas en el riesgo
        if (!risk.causas || risk.causas.length === 0) {
          errors.push(
            `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "no tiene causas asociadas"
            )}`
          );
        }
        // Verificar que existan impactos en el riesgo
        if (!risk.impactos || risk.impactos.length === 0) {
          errors.push(
            `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "no tiene impactos asociados"
            )}`
          );
        }
        // Verifica que todas las causas tengan controles preventivos
        if (risk.causas.length > 0) {
          risk.causas.forEach(causa => {
            if (
              !causa.controles_preventivos ||
              causa.controles_preventivos.length === 0
            ) {
              errors.push(
                `Riesgo "${risk.nombre}", ${this.$t("Causa")} '${
                  causa.nombre
                }' ${this.$t("no tiene controles preventivos asociados")}`
              );
            }
          });
        } else {
          errors.push(
            `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "no tiene controles preventivos asociados"
            )}`
          );
        }

        // Si es MFL < 3, no es necesario agregar controles mitigadores
        // Verifica que todos los impactos tengan controles mitigadores
        risk.impactos.forEach(impacto => {
          if (
            !impacto.controles_mitigadores ||
            impacto.controles_mitigadores.length === 0
          ) {
            errors.push(
              `Riesgo "${risk.nombre}", ${this.$t("Impacto")} con categoría '${
                impacto.tipo
              }' ${this.$t("no tiene controles mitigadores asociados")}`
            );
          }
        });

        // Valida Equipo Evaluador
        if (!risk.evaluadores || risk.evaluadores.length === 0) {
          errors.push(
            `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "no tiene ningún evaluador"
            )}`
          );
        }
        // Valida escenarios
        /* if (!risk.escenario || risk.escenario === '') {
          errors.push(
            `${this.$t('Riesgo')} "${risk.nombre}" ${this.$t(
              'no tiene escenario',
            )}`,
          );
        } */

        if (risk.tipo === "medioambiente") {
          if (!risk.medioambiente.responsable) {
            errors.push(
              `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
                "no tiene responsable"
              )}`
            );
          }

          if (!risk.medioambiente.evento) {
            errors.push(
              `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
                "no tiene evento"
              )}`
            );
          }

          if (!risk.medioambiente.condicion) {
            errors.push(
              `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
                "no tiene condición"
              )}`
            );
          }

          if (!risk.medioambiente.equipo) {
            errors.push(
              `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
                "no tiene equipo crítico"
              )}`
            );
          }
        }

        if (errors.length > 0) {
          return { status: false, errors };
        }
        return { status: true, errors };
      }
      return { status: true, errors };
    },
    setIdRisk() {
      this.newCustomRisk._id = uuid();
    },
    deleteRisk(risk) {
      this.$confirm(
        `Estás a punto de eliminar el riesgo "${risk.nombre}". Continuar?`,
        "Advertencia",
        {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning"
        }
      )
        .then(() => {
          this.$store.dispatch("deleteCustomRisk", risk);
          this.$notify.info({
            duration: 3000,
            title: "Atención",
            message: `${this.$t("Riesgo")} "${risk.nombre}" ${this.$t(
              "eliminado exitosamente"
            )}`
          });
          this.saveInventory();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Acción cancelada"
          });
        });
    },
    closeDialogCustomRisk() {
      this.formCustomRisk.nombre = "";
      this.formCustomRisk.tipo = null;
      this.dialogNewCustomRisk = false;
      this.standard_risks = [];
      this.standard_risks_original = [];
      this.standard_risk_found = false;
      this.standard_risk_message = "";
      this.noStandardRiskLeft = false;
      this.srrLoading = false;
      this.formCustomRisk.standardRisk = null;
      this.standardRiskButtonEnabled = false;
    },
    closeDialogEditCustomRisk() {
      this.formCustomRisk.nombre = "";
      this.formCustomRisk.tipo = null;
      this.dialogEditCustomRisk = false;
    },
    previousStep() {
      if (this.taskName !== "") {
        this.assignTaskName();
        const url = `/inventario/${this.$store.getters.actualContract._id}/editar`;
        this.$router.push({
          path: url
        });
      }
      if (this.taskName === "" && this.cantidadRiesgos > 0) {
        this.$message({
          type: "warning",
          message: "Se debe asignar el nombre de la tarea para regresar"
        });
      }
      if (this.taskName === "" && this.cantidadRiesgos === 0) {
        this.$store
          .dispatch(
            "deleteTask",
            this.$store.getters.inventario.tareas[
              this.$store.getters.selectedIndexTask
            ]
          )
          .then(() => {
            this.$store.dispatch("createOrUpdateDraft").then(response => {
              if (response.success) {
                this.saveInventory();
                this.$router.push({
                  name: `/inventario/${contract._id}/editar`
                });
              } else {
                this.$alert(response.message, this.$t("Atención"), {
                  type: "error"
                });
              }
            });
          });
        const url = `/inventario/${this.$store.getters.actualContract._id}/editar`;
        this.$router.push({
          path: url
        });
      }
    },
    nextStep() {
      if (this.taskName !== "") {
        this.assignTaskName();
        this.errores = [];
        let errors = [];
        this.$store.getters.inventario.tareas[
          this.$store.getters.selectedIndexTask
        ].riesgos.forEach(risk => {
          errors = errors.concat(this.isRiskReady(risk).errors);
        });
        this.isLoading = false;
        if (errors.length > 0) {
          this.errores = errors;
          this.dialogError = true;
          return;
        }
        this.$router.push({ name: this.mel ? "summaryStep" : "secondStep" });
      } else {
        this.$message({
          type: "warning",
          message: "Se debe asignar el nombre de la tarea para continuar"
        });
      }
    }
  }
};
</script>

<style>
.countRisk {
  font-size: 31px;
  color: rgb(230, 84, 0);
  font-weight: bold;
}
.nameTask {
  font-size: 21px;
}
.tableRisks {
  margin-top: 10px;
}
.headerCell {
  padding: 0px !important;
}
.cuadrado {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0px;
  top: 0px;
}
.listaError {
  margin-left: 13px;
  padding: 0px;
  margin-bottom: 5px;
}

.alertError {
  width: 70%;
}
.fontRed {
  color: red;
}

.messageTask {
  font-size: 13px !important;
}

.title-task {
  margin-bottom: 0px !important;
}

.intermitente {
  padding: 15px 15px;
  box-shadow: 0px 0px 20px;
  color: rgb(230, 84, 0);
  animation: infinite resplandorAnimation 2s;
}
@keyframes resplandorAnimation {
  0%,
  100% {
    box-shadow: 0px 0px 20px;
  }
  50% {
    box-shadow: 0px 0px 0px;
  }
}
</style>
